import React from "react";
import AddProfileDetails from "../../../../components/MainPages/Account/AddProfileDetails";

const ProfileDetails = ({ user }) => {
  return (
    <>
      <AddProfileDetails user={user} />
    </>
  );
};

export default ProfileDetails;
